import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function ForbiddenPage() {
  return (
    <>
      <SEO
        title="403 - Adgang nægtet"
        description="Du har ikke adgang til denne side på Insightly Care."
      />

      <section className="min-h-[60vh] flex items-center justify-center py-20 bg-slate-50">
        <div className="max-w-md w-full px-4 text-center space-y-6">
          <div className="w-20 h-20 bg-slate-200 text-black flex items-center justify-center text-4xl mx-auto">
            <i className="fa-solid fa-lock text-black" aria-hidden="true" />
          </div>

          <div className="space-y-2">
            <span className="text-xs font-black uppercase tracking-widest text-black">
              Fejl 403
            </span>
            <h1 className="text-3xl font-extrabold text-black tracking-tight">
              Adgang nægtet
            </h1>
            <p className="text-black text-sm leading-relaxed">
              Du har desværre ikke den nødvendige tilladelse til at se denne ressourse.
            </p>
          </div>

          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto px-6 py-3 bg-slate-900 hover:bg-black text-white font-bold transition-colors"
            >
              Gå til Forsiden
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto px-6 py-3 bg-white hover:bg-slate-100 text-black font-bold border border-slate-300 transition-colors"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
